namespace Portico.Services {
    import IServiceDefinition = Portico.Models.Interfaces.IServiceDefinition;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export abstract class EnterpriseServiceBase extends ServiceBase<IServiceDefinition> {
        constructor(
            $http: ng.IHttpService,
            $q: ng.IQService,
            dataService: Portico.Services.DataService,
            modalService: Portico.Services.IModalService,
            errorService: Portico.Services.IErrorService,
            $rootScope: ng.IRootScopeService,
            private tokenService: Portico.Services.ITokenService,
            private secureKeyId: string
        ) {
            super($http, $q, dataService, modalService, errorService, $rootScope);
        }

        protected requestToken(serviceUrl: IServiceDefinition): ng.IPromise<string> {
            return this.tokenService.requestToken(serviceUrl);
        }

        protected getHttpConfig(serviceUrl: IServiceDefinition, token: string): ng.IRequestConfig {
            const config = {} as ng.IRequestConfig;

            config.headers = {
                'Authorization': token
            };

            config.headers['x-tc-userid'] = this.dataService.getEnvironmentValue(this.secureKeyId);

            return config;
        };
    }

    @Service('app', 'legacyService')
    @Inject('$http', '$q', 'dataService', 'modalService', 'errorService', '$rootScope', 'tokenService')
    export class LegacyService extends EnterpriseServiceBase {
        constructor(
            $http: ng.IHttpService,
            $q: ng.IQService,
            dataService: Portico.Services.DataService,
            modalService: Portico.Services.IModalService,
            errorService: Portico.Services.IErrorService,
            $rootScope: ng.IRootScopeService,
            tokenService: Portico.Services.ITokenService
        ) {
            super($http, $q, dataService, modalService, errorService, $rootScope, tokenService, Portico.Models.KnownKeyNames.legacyProgramSecureId);
        }
    }

    @Service('app', 'entService')
    @Inject('$http', '$q', 'dataService', 'modalService', 'errorService', '$rootScope', 'tokenService')
    export class EntService extends EnterpriseServiceBase {
        constructor(
            $http: ng.IHttpService,
            $q: ng.IQService,
            dataService: Portico.Services.DataService,
            modalService: Portico.Services.IModalService,
            errorService: Portico.Services.IErrorService,
            $rootScope: ng.IRootScopeService,
            tokenService: Portico.Services.ITokenService
        ) {
            super($http, $q, dataService, modalService, errorService, $rootScope, tokenService, Portico.Models.KnownKeyNames.secureId);
        }
    }
}